import { render, staticRenderFns } from "./subContentTools.vue?vue&type=template&id=2bc5d16f"
import script from "./subContentTools.vue?vue&type=script&lang=js"
export * from "./subContentTools.vue?vue&type=script&lang=js"
import style0 from "./subContentTools.vue?vue&type=style&index=0&id=2bc5d16f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports